import React, {
  createContext, useContext, useEffect, useState,
} from 'react';
import { useLocation } from 'react-router-dom';

interface ContextState {
  currentPage: string | null;
  prevPage: string | null;
}

const context = createContext<ContextState>({ currentPage: null, prevPage: null });

export function usePrevPage() {
  return useContext(context);
}

export interface PrevPageProviderProps {
  children: React.ReactNode;
}

export function PrevPageProvider({ children }: PrevPageProviderProps) {
  const { pathname } = useLocation();
  const [state, setState] = useState<ContextState>({ currentPage: null, prevPage: null });

  useEffect(() => {
    if (state.currentPage === pathname) return;

    setState({
      currentPage: pathname,
      prevPage: state.currentPage,
    });
  }, [pathname]);

  return (
    <context.Provider value={state}>
      {children}
    </context.Provider>
  );
}
